/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SecurityHelper } from 'sarsaparilla';
import { apiHelpers } from 'ui-lottery/src/api/helpers';
import * as endpoints from './endpoints';

import { defaultData } from '../../__tests__/mock_store';

const { get, getWithAuth, postWithAuth } = apiHelpers(SecurityHelper);

export const addReservation = () =>
    new Promise((resolve) => {
        resolve({ data: { payload: defaultData.treePermit.reservation.data } });
    });
export const updateReservation = (request: Record<string, unknown>) =>
    postWithAuth(endpoints.reservationEndpoint(), request);
export const fetchPermit = () =>
    new Promise((resolve) => {
        resolve({ data: { payload: defaultData.treePermit.permit.data } });
    });

// export const fetchUnpaidReservation = fetchReservation;

// availability
export const fetchAvailability = (id: string, year: string) =>
    get(endpoints.availability(id, year));

//reservation

export const createReservation = (request: Record<string, unknown>) =>
    postWithAuth(endpoints.reservationEndpoint(), request);
export const getReservationById = (id: string) =>
    getWithAuth(endpoints.reservationByIdEndpoint(id));

// Locations
export const getLocation = (id: string) => get(endpoints.treePermit(id));
export const getPermitTypes = (id: string, active: boolean) =>
    get(endpoints.treePermitTypes(id, active));
export const getSeasons = (id: string, year: string) => get(endpoints.seasons(id, year));
export const getParentAsset = (id: string) => getWithAuth(endpoints.recarea(id));
export const getLocations = () => get(endpoints.locationsEndpoint());
export const searchPermitTypes = () => get(endpoints.searchPermitTypesEndpoint());
export const searchLocations = (criteria: string) =>
    get(endpoints.searchLocationsEndpoint(criteria));

// price

export const getPrice = (request: {
    permit_type_id: string | undefined;
    trees_number: number;
    ekopass?: any;
}) => postWithAuth(endpoints.priceEndpoint(), request);
export const getValidate = (request: Record<string, unknown>) =>
    postWithAuth(endpoints.validateEndpoint(), request);

// cspell:ignore recarea
